import type { MenuStyles } from "./menu-item";

export function MenuRetry({
  message,
  label,
  onRetry,
  styles,
}: {
  readonly message: string;
  readonly label: string;
  readonly onRetry: () => void;
  readonly styles: MenuStyles;
}) {
  return (
    <li className={styles.heading}>
      <output>{message}</output>
      <button type="button" className={styles.item} onClick={onRetry}>
        {label}
      </button>
    </li>
  );
}
